/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccountDto } from '../models/account-dto';
import { createAdmin } from '../fn/admin-users-api/create-admin';
import { CreateAdmin$Params } from '../fn/admin-users-api/create-admin';
import { createUser } from '../fn/admin-users-api/create-user';
import { CreateUser$Params } from '../fn/admin-users-api/create-user';
import { deleteAuthProvider1 } from '../fn/admin-users-api/delete-auth-provider-1';
import { DeleteAuthProvider1$Params } from '../fn/admin-users-api/delete-auth-provider-1';
import { deleteUser } from '../fn/admin-users-api/delete-user';
import { DeleteUser$Params } from '../fn/admin-users-api/delete-user';
import { deleteUser1 } from '../fn/admin-users-api/delete-user-1';
import { DeleteUser1$Params } from '../fn/admin-users-api/delete-user-1';
import { getAccount } from '../fn/admin-users-api/get-account';
import { GetAccount$Params } from '../fn/admin-users-api/get-account';
import { getAccount1 } from '../fn/admin-users-api/get-account-1';
import { GetAccount1$Params } from '../fn/admin-users-api/get-account-1';
import { getAdmins } from '../fn/admin-users-api/get-admins';
import { GetAdmins$Params } from '../fn/admin-users-api/get-admins';
import { getAllNotifications1 } from '../fn/admin-users-api/get-all-notifications-1';
import { GetAllNotifications1$Params } from '../fn/admin-users-api/get-all-notifications-1';
import { getAllTopics1 } from '../fn/admin-users-api/get-all-topics-1';
import { GetAllTopics1$Params } from '../fn/admin-users-api/get-all-topics-1';
import { getInvitedBy } from '../fn/admin-users-api/get-invited-by';
import { GetInvitedBy$Params } from '../fn/admin-users-api/get-invited-by';
import { getInvites1 } from '../fn/admin-users-api/get-invites-1';
import { GetInvites1$Params } from '../fn/admin-users-api/get-invites-1';
import { getNotificationMethods1 } from '../fn/admin-users-api/get-notification-methods-1';
import { GetNotificationMethods1$Params } from '../fn/admin-users-api/get-notification-methods-1';
import { getNotificationOption1 } from '../fn/admin-users-api/get-notification-option-1';
import { GetNotificationOption1$Params } from '../fn/admin-users-api/get-notification-option-1';
import { getNotificationOptions1 } from '../fn/admin-users-api/get-notification-options-1';
import { GetNotificationOptions1$Params } from '../fn/admin-users-api/get-notification-options-1';
import { getNotificationTypes1 } from '../fn/admin-users-api/get-notification-types-1';
import { GetNotificationTypes1$Params } from '../fn/admin-users-api/get-notification-types-1';
import { getUser } from '../fn/admin-users-api/get-user';
import { GetUser$Params } from '../fn/admin-users-api/get-user';
import { getUser1 } from '../fn/admin-users-api/get-user-1';
import { GetUser1$Params } from '../fn/admin-users-api/get-user-1';
import { getUserAuthorization } from '../fn/admin-users-api/get-user-authorization';
import { GetUserAuthorization$Params } from '../fn/admin-users-api/get-user-authorization';
import { getUsers } from '../fn/admin-users-api/get-users';
import { GetUsers$Params } from '../fn/admin-users-api/get-users';
import { invalidatePrivacyAgreements } from '../fn/admin-users-api/invalidate-privacy-agreements';
import { InvalidatePrivacyAgreements$Params } from '../fn/admin-users-api/invalidate-privacy-agreements';
import { invalidateTermsAgreements } from '../fn/admin-users-api/invalidate-terms-agreements';
import { InvalidateTermsAgreements$Params } from '../fn/admin-users-api/invalidate-terms-agreements';
import { InviteDto } from '../models/invite-dto';
import { NotificationOptionDto } from '../models/notification-option-dto';
import { PageDtoNotificationNotificationDto } from '../models/page-dto-notification-notification-dto';
import { PageDtoUserUserDto } from '../models/page-dto-user-user-dto';
import { restoreAdmin } from '../fn/admin-users-api/restore-admin';
import { RestoreAdmin$Params } from '../fn/admin-users-api/restore-admin';
import { restoreUser } from '../fn/admin-users-api/restore-user';
import { RestoreUser$Params } from '../fn/admin-users-api/restore-user';
import { SimpleList } from '../models/simple-list';
import { subscribe2 } from '../fn/admin-users-api/subscribe-2';
import { Subscribe2$Params } from '../fn/admin-users-api/subscribe-2';
import { TopicDto } from '../models/topic-dto';
import { unSubscribe1 } from '../fn/admin-users-api/un-subscribe-1';
import { UnSubscribe1$Params } from '../fn/admin-users-api/un-subscribe-1';
import { updateAccount } from '../fn/admin-users-api/update-account';
import { UpdateAccount$Params } from '../fn/admin-users-api/update-account';
import { updateAdmin } from '../fn/admin-users-api/update-admin';
import { UpdateAdmin$Params } from '../fn/admin-users-api/update-admin';
import { updateUser } from '../fn/admin-users-api/update-user';
import { UpdateUser$Params } from '../fn/admin-users-api/update-user';
import { updateUserNotificationOption1 } from '../fn/admin-users-api/update-user-notification-option-1';
import { UpdateUserNotificationOption1$Params } from '../fn/admin-users-api/update-user-notification-option-1';
import { updateUserPassword1 } from '../fn/admin-users-api/update-user-password-1';
import { UpdateUserPassword1$Params } from '../fn/admin-users-api/update-user-password-1';
import { updateUserPermissionGroups } from '../fn/admin-users-api/update-user-permission-groups';
import { UpdateUserPermissionGroups$Params } from '../fn/admin-users-api/update-user-permission-groups';
import { updateUserPermissions } from '../fn/admin-users-api/update-user-permissions';
import { UpdateUserPermissions$Params } from '../fn/admin-users-api/update-user-permissions';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class AdminUsersApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getNotificationOption1()` */
  static readonly GetNotificationOption1Path = '/api/admin/users/{userId}/notifications/options/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationOption1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOption1$Response(params: GetNotificationOption1$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationOptionDto>> {
    return getNotificationOption1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationOption1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOption1(params: GetNotificationOption1$Params, context?: HttpContext): Observable<NotificationOptionDto> {
    return this.getNotificationOption1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationOptionDto>): NotificationOptionDto => r.body)
    );
  }

  /** Path part for operation `updateUserNotificationOption1()` */
  static readonly UpdateUserNotificationOption1Path = '/api/admin/users/{userId}/notifications/options/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserNotificationOption1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserNotificationOption1$Response(params: UpdateUserNotificationOption1$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationOptionDto>> {
    return updateUserNotificationOption1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserNotificationOption1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserNotificationOption1(params: UpdateUserNotificationOption1$Params, context?: HttpContext): Observable<NotificationOptionDto> {
    return this.updateUserNotificationOption1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationOptionDto>): NotificationOptionDto => r.body)
    );
  }

  /** Path part for operation `getUser()` */
  static readonly GetUserPath = '/api/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser$Response(params: GetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return getUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: GetUser$Params, context?: HttpContext): Observable<UserDto> {
    return this.getUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/api/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return updateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<UserDto> {
    return this.updateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `deleteUser()` */
  static readonly DeleteUserPath = '/api/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser$Response(params: DeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(params: DeleteUser$Params, context?: HttpContext): Observable<void> {
    return this.deleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAccount()` */
  static readonly GetAccountPath = '/api/admin/users/{id}/account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccount$Response(params: GetAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountDto>> {
    return getAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccount(params: GetAccount$Params, context?: HttpContext): Observable<AccountDto> {
    return this.getAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccountDto>): AccountDto => r.body)
    );
  }

  /** Path part for operation `updateAccount()` */
  static readonly UpdateAccountPath = '/api/admin/users/{id}/account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAccount$Response(params: UpdateAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountDto>> {
    return updateAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAccount(params: UpdateAccount$Params, context?: HttpContext): Observable<AccountDto> {
    return this.updateAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccountDto>): AccountDto => r.body)
    );
  }

  /** Path part for operation `getUser1()` */
  static readonly GetUser1Path = '/api/admin/admins/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser1$Response(params: GetUser1$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return getUser1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser1(params: GetUser1$Params, context?: HttpContext): Observable<UserDto> {
    return this.getUser1$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `updateAdmin()` */
  static readonly UpdateAdminPath = '/api/admin/admins/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdmin$Response(params: UpdateAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return updateAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdmin(params: UpdateAdmin$Params, context?: HttpContext): Observable<UserDto> {
    return this.updateAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `deleteUser1()` */
  static readonly DeleteUser1Path = '/api/admin/admins/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser1$Response(params: DeleteUser1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUser1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser1(params: DeleteUser1$Params, context?: HttpContext): Observable<void> {
    return this.deleteUser1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserPermissions()` */
  static readonly UpdateUserPermissionsPath = '/api/admin/admins/{id}/permissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPermissions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPermissions$Response(params: UpdateUserPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return updateUserPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPermissions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPermissions(params: UpdateUserPermissions$Params, context?: HttpContext): Observable<UserDto> {
    return this.updateUserPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `updateUserPermissionGroups()` */
  static readonly UpdateUserPermissionGroupsPath = '/api/admin/admins/{id}/permissionGroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPermissionGroups()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPermissionGroups$Response(params: UpdateUserPermissionGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return updateUserPermissionGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPermissionGroups$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPermissionGroups(params: UpdateUserPermissionGroups$Params, context?: HttpContext): Observable<UserDto> {
    return this.updateUserPermissionGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `updateUserPassword1()` */
  static readonly UpdateUserPassword1Path = '/api/admin/admins/{id}/password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPassword1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPassword1$Response(params: UpdateUserPassword1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUserPassword1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPassword1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPassword1(params: UpdateUserPassword1$Params, context?: HttpContext): Observable<void> {
    return this.updateUserPassword1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUsers()` */
  static readonly GetUsersPath = '/api/admin/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(params: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoUserUserDto>> {
    return getUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(params: GetUsers$Params, context?: HttpContext): Observable<PageDtoUserUserDto> {
    return this.getUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoUserUserDto>): PageDtoUserUserDto => r.body)
    );
  }

  /** Path part for operation `createUser()` */
  static readonly CreateUserPath = '/api/admin/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(params: CreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return createUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params: CreateUser$Params, context?: HttpContext): Observable<UserDto> {
    return this.createUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `unSubscribe1()` */
  static readonly UnSubscribe1Path = '/api/admin/users/{userId}/news/topics/{topicId}/unsubscribe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unSubscribe1()` instead.
   *
   * This method doesn't expect any request body.
   */
  unSubscribe1$Response(params: UnSubscribe1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unSubscribe1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unSubscribe1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unSubscribe1(params: UnSubscribe1$Params, context?: HttpContext): Observable<void> {
    return this.unSubscribe1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscribe2()` */
  static readonly Subscribe2Path = '/api/admin/users/{userId}/news/topics/{topicId}/subscribe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribe2()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribe2$Response(params: Subscribe2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribe2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribe2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribe2(params: Subscribe2$Params, context?: HttpContext): Observable<void> {
    return this.subscribe2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `restoreUser()` */
  static readonly RestoreUserPath = '/api/admin/users/{id}/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreUser$Response(params: RestoreUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return restoreUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreUser(params: RestoreUser$Params, context?: HttpContext): Observable<UserDto> {
    return this.restoreUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `getAdmins()` */
  static readonly GetAdminsPath = '/api/admin/admins';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdmins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdmins$Response(params: GetAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoUserUserDto>> {
    return getAdmins(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdmins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdmins(params: GetAdmins$Params, context?: HttpContext): Observable<PageDtoUserUserDto> {
    return this.getAdmins$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoUserUserDto>): PageDtoUserUserDto => r.body)
    );
  }

  /** Path part for operation `createAdmin()` */
  static readonly CreateAdminPath = '/api/admin/admins';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdmin$Response(params: CreateAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return createAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdmin(params: CreateAdmin$Params, context?: HttpContext): Observable<UserDto> {
    return this.createAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `restoreAdmin()` */
  static readonly RestoreAdminPath = '/api/admin/admins/{id}/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreAdmin$Response(params: RestoreAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return restoreAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreAdmin(params: RestoreAdmin$Params, context?: HttpContext): Observable<UserDto> {
    return this.restoreAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `getAllNotifications1()` */
  static readonly GetAllNotifications1Path = '/api/admin/users/{userId}/notifications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllNotifications1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllNotifications1$Response(params: GetAllNotifications1$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoNotificationNotificationDto>> {
    return getAllNotifications1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllNotifications1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllNotifications1(params: GetAllNotifications1$Params, context?: HttpContext): Observable<PageDtoNotificationNotificationDto> {
    return this.getAllNotifications1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoNotificationNotificationDto>): PageDtoNotificationNotificationDto => r.body)
    );
  }

  /** Path part for operation `getNotificationOptions1()` */
  static readonly GetNotificationOptions1Path = '/api/admin/users/{userId}/notifications/options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationOptions1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOptions1$Response(params: GetNotificationOptions1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotificationOptionDto>>> {
    return getNotificationOptions1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationOptions1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOptions1(params: GetNotificationOptions1$Params, context?: HttpContext): Observable<Array<NotificationOptionDto>> {
    return this.getNotificationOptions1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NotificationOptionDto>>): Array<NotificationOptionDto> => r.body)
    );
  }

  /** Path part for operation `getAllTopics1()` */
  static readonly GetAllTopics1Path = '/api/admin/users/{userId}/news/topics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTopics1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTopics1$Response(params: GetAllTopics1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TopicDto>>> {
    return getAllTopics1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTopics1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTopics1(params: GetAllTopics1$Params, context?: HttpContext): Observable<Array<TopicDto>> {
    return this.getAllTopics1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TopicDto>>): Array<TopicDto> => r.body)
    );
  }

  /** Path part for operation `getInvites1()` */
  static readonly GetInvites1Path = '/api/admin/users/{userId}/invites';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvites1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvites1$Response(params: GetInvites1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InviteDto>>> {
    return getInvites1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInvites1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvites1(params: GetInvites1$Params, context?: HttpContext): Observable<Array<InviteDto>> {
    return this.getInvites1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InviteDto>>): Array<InviteDto> => r.body)
    );
  }

  /** Path part for operation `getInvitedBy()` */
  static readonly GetInvitedByPath = '/api/admin/users/{userId}/invitedBy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvitedBy()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvitedBy$Response(params: GetInvitedBy$Params, context?: HttpContext): Observable<StrictHttpResponse<InviteDto>> {
    return getInvitedBy(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInvitedBy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvitedBy(params: GetInvitedBy$Params, context?: HttpContext): Observable<InviteDto> {
    return this.getInvitedBy$Response(params, context).pipe(
      map((r: StrictHttpResponse<InviteDto>): InviteDto => r.body)
    );
  }

  /** Path part for operation `getAccount1()` */
  static readonly GetAccount1Path = '/api/admin/users/phoneCountryCodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccount1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccount1$Response(params?: GetAccount1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getAccount1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccount1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccount1(params?: GetAccount1$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getAccount1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `getNotificationTypes1()` */
  static readonly GetNotificationTypes1Path = '/api/admin/users/notifications/types/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationTypes1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationTypes1$Response(params?: GetNotificationTypes1$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getNotificationTypes1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationTypes1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationTypes1(params?: GetNotificationTypes1$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getNotificationTypes1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getNotificationMethods1()` */
  static readonly GetNotificationMethods1Path = '/api/admin/users/notifications/methods/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationMethods1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationMethods1$Response(params?: GetNotificationMethods1$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getNotificationMethods1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationMethods1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationMethods1(params?: GetNotificationMethods1$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getNotificationMethods1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getUserAuthorization()` */
  static readonly GetUserAuthorizationPath = '/api/admin/admins/{id}/authorization';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAuthorization()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAuthorization$Response(params: GetUserAuthorization$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'ADMIN_READ' | 'ADMIN_READALL' | 'ADMIN_CREATE' | 'ADMIN_UPDATE' | 'ADMIN_DELETE' | 'ADMIN_PERMISSION_UPDATE' | 'ADMIN_PERMISSION_GROUP_UPDATE' | 'BOOKING_READ' | 'BOOKING_CLONE' | 'BOOKING_TERMINATE' | 'BOOKING_SHARE_READ' | 'BOOKING_SHARE_CREATE' | 'BOOKING_SHARE_UPDATE' | 'BOOKING_SHARE_DELETE' | 'BOOKING_UPDATE' | 'HELP_PAGE_READ' | 'HELP_PAGE_CREATE' | 'HELP_PAGE_UPDATE' | 'HELP_PAGE_DELETE' | 'IMAGE_READ' | 'IMAGE_CREATE' | 'IMAGE_UPDATE' | 'IMAGE_DELETE' | 'LOG_READ' | 'NEWS_READ' | 'NEWS_CREATE' | 'NEWS_UPDATE' | 'NEWS_DELETE' | 'NOTIFICATION_SEND' | 'ORGANIZATION_READ' | 'ORGANIZATION_CONTACT_READ' | 'ORGANIZATION_CONTACT_CREATE' | 'ORGANIZATION_CONTACT_UPDATE' | 'ORGANIZATION_CONTACT_DELETE' | 'ORGANIZATION_PERMISSION_GROUP_READ' | 'ORGANIZATION_PERMISSION_GROUP_CREATE' | 'ORGANIZATION_PERMISSION_GROUP_UPDATE' | 'ORGANIZATION_PERMISSION_GROUP_DELETE' | 'ORGANIZATION_USER_READ' | 'ORGANIZATION_ADMIN_READ' | 'ORGANIZATION_TOWER_GROUP_READ' | 'PAYMENT_READ' | 'PAYMENT_REFUND' | 'PAYMENT_REPAY' | 'INVOICE_CREATE' | 'INVOICE_DOWNLOAD' | 'PARTNER_PAYMENT_READ' | 'PINPAD_READ' | 'PINPAD_CREATE' | 'PINPAD_UPDATE' | 'PINPAD_DELETE' | 'PINPAD_RESET' | 'SUBSCRIPTION_READ' | 'SUBSCRIPTION_CREATE' | 'SUBSCRIPTION_CANCEL' | 'SUBSCRIPTION_UPDATE' | 'TOWER_CREATE' | 'TOWER_UPDATE' | 'TOWER_DELETE' | 'TOWER_RESET' | 'TOWER_BLOCK' | 'TOWER_UNBLOCK' | 'TOWER_HEARTBEAT_REQUEST' | 'TOWER_WEBCAM_ACCESS' | 'TOWER_BOX_UPDATE' | 'TOWER_BOX_OPEN' | 'TOWER_BOX_CLOSE' | 'TOWER_GROUP_READ' | 'TOWER_GROUP_CREATE' | 'TOWER_GROUP_UPDATE' | 'TOWER_GROUP_DELETE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_UPDATE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_DELETE' | 'TOWER_GROUP_DETAIL_READ' | 'TOWER_GROUP_DETAIL_CREATE' | 'TOWER_GROUP_DETAIL_UPDATE' | 'TOWER_GROUP_DETAIL_DELETE' | 'TOWER_WISH_READ' | 'TOWER_WISH_UPDATE' | 'TOWER_WISH_DELETE' | 'USER_READ' | 'USER_CREATE' | 'USER_UPDATE' | 'USER_DELETE' | 'USER_ACCOUNT_UPDATE' | 'USER_NOTIFICATION_READ' | 'USER_NOTIFICATION_OPTION_READ' | 'USER_NOTIFICATION_OPTION_UPDATE' | 'USER_TOPIC_SUBSCRIBE_READ' | 'USER_TOPIC_SUBSCRIBE_UPDATE' | 'USER_PROVIDER_DELETE' | 'USER_PRIVACY_AGREEMENT_DELETE' | 'USER_TERMS_AGREEMENT_DELETE' | 'USER_INVITE_READ' | 'VOUCHER_READ' | 'VOUCHER_CREATE' | 'VOUCHER_UPDATE' | 'VOUCHER_DELETE'>>> {
    return getUserAuthorization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAuthorization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAuthorization(params: GetUserAuthorization$Params, context?: HttpContext): Observable<Array<'ADMIN_READ' | 'ADMIN_READALL' | 'ADMIN_CREATE' | 'ADMIN_UPDATE' | 'ADMIN_DELETE' | 'ADMIN_PERMISSION_UPDATE' | 'ADMIN_PERMISSION_GROUP_UPDATE' | 'BOOKING_READ' | 'BOOKING_CLONE' | 'BOOKING_TERMINATE' | 'BOOKING_SHARE_READ' | 'BOOKING_SHARE_CREATE' | 'BOOKING_SHARE_UPDATE' | 'BOOKING_SHARE_DELETE' | 'BOOKING_UPDATE' | 'HELP_PAGE_READ' | 'HELP_PAGE_CREATE' | 'HELP_PAGE_UPDATE' | 'HELP_PAGE_DELETE' | 'IMAGE_READ' | 'IMAGE_CREATE' | 'IMAGE_UPDATE' | 'IMAGE_DELETE' | 'LOG_READ' | 'NEWS_READ' | 'NEWS_CREATE' | 'NEWS_UPDATE' | 'NEWS_DELETE' | 'NOTIFICATION_SEND' | 'ORGANIZATION_READ' | 'ORGANIZATION_CONTACT_READ' | 'ORGANIZATION_CONTACT_CREATE' | 'ORGANIZATION_CONTACT_UPDATE' | 'ORGANIZATION_CONTACT_DELETE' | 'ORGANIZATION_PERMISSION_GROUP_READ' | 'ORGANIZATION_PERMISSION_GROUP_CREATE' | 'ORGANIZATION_PERMISSION_GROUP_UPDATE' | 'ORGANIZATION_PERMISSION_GROUP_DELETE' | 'ORGANIZATION_USER_READ' | 'ORGANIZATION_ADMIN_READ' | 'ORGANIZATION_TOWER_GROUP_READ' | 'PAYMENT_READ' | 'PAYMENT_REFUND' | 'PAYMENT_REPAY' | 'INVOICE_CREATE' | 'INVOICE_DOWNLOAD' | 'PARTNER_PAYMENT_READ' | 'PINPAD_READ' | 'PINPAD_CREATE' | 'PINPAD_UPDATE' | 'PINPAD_DELETE' | 'PINPAD_RESET' | 'SUBSCRIPTION_READ' | 'SUBSCRIPTION_CREATE' | 'SUBSCRIPTION_CANCEL' | 'SUBSCRIPTION_UPDATE' | 'TOWER_CREATE' | 'TOWER_UPDATE' | 'TOWER_DELETE' | 'TOWER_RESET' | 'TOWER_BLOCK' | 'TOWER_UNBLOCK' | 'TOWER_HEARTBEAT_REQUEST' | 'TOWER_WEBCAM_ACCESS' | 'TOWER_BOX_UPDATE' | 'TOWER_BOX_OPEN' | 'TOWER_BOX_CLOSE' | 'TOWER_GROUP_READ' | 'TOWER_GROUP_CREATE' | 'TOWER_GROUP_UPDATE' | 'TOWER_GROUP_DELETE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_UPDATE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_DELETE' | 'TOWER_GROUP_DETAIL_READ' | 'TOWER_GROUP_DETAIL_CREATE' | 'TOWER_GROUP_DETAIL_UPDATE' | 'TOWER_GROUP_DETAIL_DELETE' | 'TOWER_WISH_READ' | 'TOWER_WISH_UPDATE' | 'TOWER_WISH_DELETE' | 'USER_READ' | 'USER_CREATE' | 'USER_UPDATE' | 'USER_DELETE' | 'USER_ACCOUNT_UPDATE' | 'USER_NOTIFICATION_READ' | 'USER_NOTIFICATION_OPTION_READ' | 'USER_NOTIFICATION_OPTION_UPDATE' | 'USER_TOPIC_SUBSCRIBE_READ' | 'USER_TOPIC_SUBSCRIBE_UPDATE' | 'USER_PROVIDER_DELETE' | 'USER_PRIVACY_AGREEMENT_DELETE' | 'USER_TERMS_AGREEMENT_DELETE' | 'USER_INVITE_READ' | 'VOUCHER_READ' | 'VOUCHER_CREATE' | 'VOUCHER_UPDATE' | 'VOUCHER_DELETE'>> {
    return this.getUserAuthorization$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<'ADMIN_READ' | 'ADMIN_READALL' | 'ADMIN_CREATE' | 'ADMIN_UPDATE' | 'ADMIN_DELETE' | 'ADMIN_PERMISSION_UPDATE' | 'ADMIN_PERMISSION_GROUP_UPDATE' | 'BOOKING_READ' | 'BOOKING_CLONE' | 'BOOKING_TERMINATE' | 'BOOKING_SHARE_READ' | 'BOOKING_SHARE_CREATE' | 'BOOKING_SHARE_UPDATE' | 'BOOKING_SHARE_DELETE' | 'BOOKING_UPDATE' | 'HELP_PAGE_READ' | 'HELP_PAGE_CREATE' | 'HELP_PAGE_UPDATE' | 'HELP_PAGE_DELETE' | 'IMAGE_READ' | 'IMAGE_CREATE' | 'IMAGE_UPDATE' | 'IMAGE_DELETE' | 'LOG_READ' | 'NEWS_READ' | 'NEWS_CREATE' | 'NEWS_UPDATE' | 'NEWS_DELETE' | 'NOTIFICATION_SEND' | 'ORGANIZATION_READ' | 'ORGANIZATION_CONTACT_READ' | 'ORGANIZATION_CONTACT_CREATE' | 'ORGANIZATION_CONTACT_UPDATE' | 'ORGANIZATION_CONTACT_DELETE' | 'ORGANIZATION_PERMISSION_GROUP_READ' | 'ORGANIZATION_PERMISSION_GROUP_CREATE' | 'ORGANIZATION_PERMISSION_GROUP_UPDATE' | 'ORGANIZATION_PERMISSION_GROUP_DELETE' | 'ORGANIZATION_USER_READ' | 'ORGANIZATION_ADMIN_READ' | 'ORGANIZATION_TOWER_GROUP_READ' | 'PAYMENT_READ' | 'PAYMENT_REFUND' | 'PAYMENT_REPAY' | 'INVOICE_CREATE' | 'INVOICE_DOWNLOAD' | 'PARTNER_PAYMENT_READ' | 'PINPAD_READ' | 'PINPAD_CREATE' | 'PINPAD_UPDATE' | 'PINPAD_DELETE' | 'PINPAD_RESET' | 'SUBSCRIPTION_READ' | 'SUBSCRIPTION_CREATE' | 'SUBSCRIPTION_CANCEL' | 'SUBSCRIPTION_UPDATE' | 'TOWER_CREATE' | 'TOWER_UPDATE' | 'TOWER_DELETE' | 'TOWER_RESET' | 'TOWER_BLOCK' | 'TOWER_UNBLOCK' | 'TOWER_HEARTBEAT_REQUEST' | 'TOWER_WEBCAM_ACCESS' | 'TOWER_BOX_UPDATE' | 'TOWER_BOX_OPEN' | 'TOWER_BOX_CLOSE' | 'TOWER_GROUP_READ' | 'TOWER_GROUP_CREATE' | 'TOWER_GROUP_UPDATE' | 'TOWER_GROUP_DELETE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_UPDATE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_DELETE' | 'TOWER_GROUP_DETAIL_READ' | 'TOWER_GROUP_DETAIL_CREATE' | 'TOWER_GROUP_DETAIL_UPDATE' | 'TOWER_GROUP_DETAIL_DELETE' | 'TOWER_WISH_READ' | 'TOWER_WISH_UPDATE' | 'TOWER_WISH_DELETE' | 'USER_READ' | 'USER_CREATE' | 'USER_UPDATE' | 'USER_DELETE' | 'USER_ACCOUNT_UPDATE' | 'USER_NOTIFICATION_READ' | 'USER_NOTIFICATION_OPTION_READ' | 'USER_NOTIFICATION_OPTION_UPDATE' | 'USER_TOPIC_SUBSCRIBE_READ' | 'USER_TOPIC_SUBSCRIBE_UPDATE' | 'USER_PROVIDER_DELETE' | 'USER_PRIVACY_AGREEMENT_DELETE' | 'USER_TERMS_AGREEMENT_DELETE' | 'USER_INVITE_READ' | 'VOUCHER_READ' | 'VOUCHER_CREATE' | 'VOUCHER_UPDATE' | 'VOUCHER_DELETE'>>): Array<'ADMIN_READ' | 'ADMIN_READALL' | 'ADMIN_CREATE' | 'ADMIN_UPDATE' | 'ADMIN_DELETE' | 'ADMIN_PERMISSION_UPDATE' | 'ADMIN_PERMISSION_GROUP_UPDATE' | 'BOOKING_READ' | 'BOOKING_CLONE' | 'BOOKING_TERMINATE' | 'BOOKING_SHARE_READ' | 'BOOKING_SHARE_CREATE' | 'BOOKING_SHARE_UPDATE' | 'BOOKING_SHARE_DELETE' | 'BOOKING_UPDATE' | 'HELP_PAGE_READ' | 'HELP_PAGE_CREATE' | 'HELP_PAGE_UPDATE' | 'HELP_PAGE_DELETE' | 'IMAGE_READ' | 'IMAGE_CREATE' | 'IMAGE_UPDATE' | 'IMAGE_DELETE' | 'LOG_READ' | 'NEWS_READ' | 'NEWS_CREATE' | 'NEWS_UPDATE' | 'NEWS_DELETE' | 'NOTIFICATION_SEND' | 'ORGANIZATION_READ' | 'ORGANIZATION_CONTACT_READ' | 'ORGANIZATION_CONTACT_CREATE' | 'ORGANIZATION_CONTACT_UPDATE' | 'ORGANIZATION_CONTACT_DELETE' | 'ORGANIZATION_PERMISSION_GROUP_READ' | 'ORGANIZATION_PERMISSION_GROUP_CREATE' | 'ORGANIZATION_PERMISSION_GROUP_UPDATE' | 'ORGANIZATION_PERMISSION_GROUP_DELETE' | 'ORGANIZATION_USER_READ' | 'ORGANIZATION_ADMIN_READ' | 'ORGANIZATION_TOWER_GROUP_READ' | 'PAYMENT_READ' | 'PAYMENT_REFUND' | 'PAYMENT_REPAY' | 'INVOICE_CREATE' | 'INVOICE_DOWNLOAD' | 'PARTNER_PAYMENT_READ' | 'PINPAD_READ' | 'PINPAD_CREATE' | 'PINPAD_UPDATE' | 'PINPAD_DELETE' | 'PINPAD_RESET' | 'SUBSCRIPTION_READ' | 'SUBSCRIPTION_CREATE' | 'SUBSCRIPTION_CANCEL' | 'SUBSCRIPTION_UPDATE' | 'TOWER_CREATE' | 'TOWER_UPDATE' | 'TOWER_DELETE' | 'TOWER_RESET' | 'TOWER_BLOCK' | 'TOWER_UNBLOCK' | 'TOWER_HEARTBEAT_REQUEST' | 'TOWER_WEBCAM_ACCESS' | 'TOWER_BOX_UPDATE' | 'TOWER_BOX_OPEN' | 'TOWER_BOX_CLOSE' | 'TOWER_GROUP_READ' | 'TOWER_GROUP_CREATE' | 'TOWER_GROUP_UPDATE' | 'TOWER_GROUP_DELETE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_UPDATE' | 'TOWER_GROUP_PAYMENT_CONFIGURATION_DELETE' | 'TOWER_GROUP_DETAIL_READ' | 'TOWER_GROUP_DETAIL_CREATE' | 'TOWER_GROUP_DETAIL_UPDATE' | 'TOWER_GROUP_DETAIL_DELETE' | 'TOWER_WISH_READ' | 'TOWER_WISH_UPDATE' | 'TOWER_WISH_DELETE' | 'USER_READ' | 'USER_CREATE' | 'USER_UPDATE' | 'USER_DELETE' | 'USER_ACCOUNT_UPDATE' | 'USER_NOTIFICATION_READ' | 'USER_NOTIFICATION_OPTION_READ' | 'USER_NOTIFICATION_OPTION_UPDATE' | 'USER_TOPIC_SUBSCRIBE_READ' | 'USER_TOPIC_SUBSCRIBE_UPDATE' | 'USER_PROVIDER_DELETE' | 'USER_PRIVACY_AGREEMENT_DELETE' | 'USER_TERMS_AGREEMENT_DELETE' | 'USER_INVITE_READ' | 'VOUCHER_READ' | 'VOUCHER_CREATE' | 'VOUCHER_UPDATE' | 'VOUCHER_DELETE'> => r.body)
    );
  }

  /** Path part for operation `deleteAuthProvider1()` */
  static readonly DeleteAuthProvider1Path = '/api/admin/users/{userId}/account/auth/provider';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthProvider1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthProvider1$Response(params: DeleteAuthProvider1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthProvider1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthProvider1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthProvider1(params: DeleteAuthProvider1$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthProvider1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invalidateTermsAgreements()` */
  static readonly InvalidateTermsAgreementsPath = '/api/admin/users/agreements/terms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invalidateTermsAgreements()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidateTermsAgreements$Response(params?: InvalidateTermsAgreements$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invalidateTermsAgreements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invalidateTermsAgreements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidateTermsAgreements(params?: InvalidateTermsAgreements$Params, context?: HttpContext): Observable<void> {
    return this.invalidateTermsAgreements$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invalidatePrivacyAgreements()` */
  static readonly InvalidatePrivacyAgreementsPath = '/api/admin/users/agreements/privacy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invalidatePrivacyAgreements()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidatePrivacyAgreements$Response(params?: InvalidatePrivacyAgreements$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invalidatePrivacyAgreements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invalidatePrivacyAgreements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidatePrivacyAgreements(params?: InvalidatePrivacyAgreements$Params, context?: HttpContext): Observable<void> {
    return this.invalidatePrivacyAgreements$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
